import { forwardRef } from "react";
import { motion } from "motion/react";
import classNames from "classnames";
import "./style.scss";

const SelectBoxItem = forwardRef(
  (
    props: {
      searchResultMode?: boolean;
      compact?: boolean;
      active?: boolean;
      setSelected: (id: number) => void;
      id: number;
      item: object;
      ItemComponent: React.FunctionComponent<{ item: object }>;
      className?: string;
    },
    _ref
  ) => {
    //ref = ref || createRef();
    const {
      searchResultMode = false,
      compact = false,
      active = false,
      setSelected,
      id,
      item,
      ItemComponent,
      className = ""
    } = props;

    return (
      <motion.div
        role="option"
        data-id={id}
        className={classNames(
          "select-box-item",
          {
            compact
          },
          className
        )}
        onClick={e => {
          setSelected?.(id);
          e.stopPropagation();
        }}
        style={{
          cursor: searchResultMode ? "default" : "pointer",
          filter: "saturate(1)",
          backgroundColor: "rgba(0,0,0,0)",
          borderBottomColor: "rgba(0,0,0,0.05)"
        }}
        initial={{ opacity: 0 }}
        exit={{
          opacity: 0,
          x: "200%",
          transition: {
            type: "spring",
            duration: 1
          }
        }}
        animate={{
          backgroundColor: active ? "rgb(252, 186, 87, 1)" : "rgba(0,0,0,0)",
          x: 0,
          opacity: 1
        }}
        whileHover={{
          filter: "saturate(1.2)",
          backgroundColor: active ? "rgb(252, 186, 87, 1)" : "rgba(0,0,0,0.05)",
          borderBottomColor: "rgba(0,0,0,0.1)"
        }}
        transition={{
          type: "tween",
          duration: 0.1,
          bounce: 0
        }}
      >
        <ItemComponent item={item} />
      </motion.div>
    );
  }
);
SelectBoxItem.displayName = "SelectBoxItem";

export default SelectBoxItem;
